module.exports = __webpack_public_path__ + "img/10.4f5f5719.svg";